import React from 'react';
import { gql } from '@apollo/client';
import { Breakpoint } from '@moda/om';
import { ProductMediaGalleryFragment } from '../../generated/types';
import {
  DesktopProductMediaGallery,
  DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT
} from './DesktopProductMediaGallery';
import {
  MobileProductMediaGallery,
  MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT
} from './MobileProductMediaGallery';
import {
  useProductMediaGalleryVideos,
  PRODUCT_MEDIA_GALLERY_VIDEOS_FRAGMENT
} from './useProductMediaGalleryVideos';

export const PRODUCT_MEDIA_GALLERY_FRAGMENT = gql`
  fragment ProductMediaGalleryFragment on Variant {
    ...DesktopProductMediaGalleryFragment
    ...MobileProductMediaGalleryFragment
    ...ProductMediaGalleryVideosFragment
  }
  ${DESKTOP_PRODUCT_MEDIA_GALLERY_FRAGMENT}
  ${MOBILE_PRODUCT_MEDIA_GALLERY_FRAGMENT}
  ${PRODUCT_MEDIA_GALLERY_VIDEOS_FRAGMENT}
`;

interface Props {
  variant: ProductMediaGalleryFragment;
}

export const ProductMediaGallery: React.FC<Props> = ({ variant }) => {
  const videos = useProductMediaGalleryVideos(variant);

  return (
    <>
      <Breakpoint gt="sm">
        <DesktopProductMediaGallery variant={{ ...variant, videos }} />
      </Breakpoint>

      <Breakpoint lt="sm">
        <MobileProductMediaGallery variant={{ ...variant, videos }} />
      </Breakpoint>
    </>
  );
};
